import { render, staticRenderFns } from "./conferenceHistoryTab.vue?vue&type=template&id=36b0a0f7&"
import script from "./conferenceHistoryTab.vue?vue&type=script&lang=js&"
export * from "./conferenceHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports